import React from "react";
import $ from "jquery";
import { BotonAddPequeño, BotonDown, BotonMenosPequeño, BotonRemovePequeño, BotonPesar, BotonMedirArea } from "../Plantillas/Botones";
import { decimalAdjust, TIPO_STOCK } from "../../Global";
import _ from 'lodash';
import MagellanListener, { KILOGRAMO_UNIT_DESCRIPTION } from "../../helpers/MagellanListener";
import { extractTwoDecimalsForNumber } from "../../helpers/calcularVenta";
import Modal from "./MedidasModal.js";
import ModalRecetaCartSVG from "../Vidrieria/Recetas/ModalRecetaCartSVG";
import { calculateAreaM2, calculateAreaPie2, calculateWasteM2, calculateWastePie2 } from "../../helpers/AreaCalculations";
import CoreModal from "../Modal";


export default class DetallesProductoPreventa extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cantidadInput: 1,
            verPrecios: true,
            magellanListenerIsAvailable: false,
            isEditing: false,
            showAreaModal: false,
            selectedAreaItem: null,
            showModalRecetaDetails: false,
            grupoRecetaSeleccionado: null,
            areaRows: [{ id: 1, cantidad: 1, ancho: "", alto: "" }],
            factorDesperdicio: 1.40,
            savedMeasurements: {}, // Store measurements by IdPresentacion
            recetasManoDeObra: {},
            recetasMedidas: {}
        }
        this.verificarPrecioCosto = this.verificarPrecioCosto.bind(this);
        this.queryParams = new URLSearchParams(window.location.search)
    }

    handleManoDeObraChange = (e, det) => {
        const rawVal = e.target.value;
        if (det.precioBase === undefined) {
            det.precioBase = parseFloat(det.PrecioVenta !== undefined ? det.PrecioVenta : (det.Precio || 0));
        }
        det.montoManoDeObra = rawVal;
        const manoObra = parseFloat(rawVal) || 0;
        const nuevoPrecio = Number((det.precioBase + manoObra).toFixed(2));

        if (this.props.InputPrecioVentaChange) {
            this.props.InputPrecioVentaChange({ target: { value: nuevoPrecio } }, det);
        }
    };

    handleManoDeObraBlur = (e, det) => {
        const rawVal = e.target.value;
        const manoObra = parseFloat(rawVal) || 0;
        const precioBase = det.precioBase !== undefined ? det.precioBase : parseFloat(det.PrecioVenta || det.Precio || 0);
        const nuevoPrecio = Number((precioBase + manoObra).toFixed(2));

        if (this.props.onBlurPrecioVenta) {
            this.props.onBlurPrecioVenta({ target: { value: nuevoPrecio } }, det);
        }
    };

    handleGuardarCambiosReceta = async (grupo, dataReceta) => {
        if (!grupo || !grupo.items || grupo.items.length === 0) return;

        const { W, H, Cantidad, montoManoDeObra, itemsRecalculados } = dataReceta;
        const montoMO = parseFloat(montoManoDeObra) || 0;

        const nuevasMedidas = {
            ...(grupo.recetaInfo || {}),
            W: W,
            H: H,
            Cantidad: Cantidad
        };

        // Registrar monto y medidas en el estado del componente
        this.setState(prevState => ({
            recetasManoDeObra: {
                ...prevState.recetasManoDeObra,
                [grupo.grupoReceta]: montoMO
            },
            recetasMedidas: {
                ...prevState.recetasMedidas,
                [grupo.grupoReceta]: nuevasMedidas
            }
        }));

        grupo.montoManoDeObra = montoMO;
        grupo.recetaInfo = nuevasMedidas;

        const medidasJSON = JSON.stringify(nuevasMedidas);

        if (this.props.onBatchUpdateDetalles) {
            const batchMap = {};
            let totalEsperadoReceta = 0;
            for (const recItem of itemsRecalculados) {
                const it = recItem.item;
                const bp = it.precioBase !== undefined ? it.precioBase : parseFloat(it.PrecioVenta !== undefined ? it.PrecioVenta : (it.Precio || 0));
                it.precioBase = bp;
                it.montoManoDeObra = recItem.moPorUnidad > 0 ? Number(recItem.moPorUnidad.toFixed(2)) : 0;
                it.medidasReceta = medidasJSON;
                it.MedidasReceta = medidasJSON;
                it.recetaInfo = nuevasMedidas;

                const sub = Number((recItem.nuevaCantidad * recItem.nuevoPrecioVenta).toFixed(2));
                totalEsperadoReceta += sub;

                const key = it.IdDetallePreventa || it.IdPresentacion;
                batchMap[key] = {
                    Cantidad: recItem.nuevaCantidad,
                    PrecioVenta: recItem.nuevoPrecioVenta,
                    montoManoDeObra: it.montoManoDeObra,
                    precioBase: bp,
                    medidasReceta: medidasJSON,
                    recetaInfo: nuevasMedidas,
                    descripcion: it.descripcion || it.Nombre
                };
                if (it.IdPresentacion) {
                    batchMap[it.IdPresentacion] = batchMap[key];
                }
            }
            console.log("%c[DetallesProductoPreventa] >> Enviando batchMap a onBatchUpdateDetalles:", "background: #17a2b8; color: white; font-weight: bold; padding: 2px 5px;");
            console.log("Total esperado calculado para la receta:", Number(totalEsperadoReceta.toFixed(2)));
            console.log("BatchMap completo:", batchMap);
            console.table(Object.keys(batchMap).map(k => ({
                Clave: k,
                Producto: batchMap[k].descripcion,
                Cantidad: batchMap[k].Cantidad,
                PrecioVenta: batchMap[k].PrecioVenta,
                ManoDeObra: batchMap[k].montoManoDeObra,
                Subtotal: Number((batchMap[k].Cantidad * batchMap[k].PrecioVenta).toFixed(2))
            })));
            await this.props.onBatchUpdateDetalles(batchMap);
        } else {
            // Fallback: Actualizar cada producto
            for (const recItem of itemsRecalculados) {
                const it = recItem.item;
                if (it.precioBase === undefined) {
                    it.precioBase = parseFloat(it.PrecioVenta !== undefined ? it.PrecioVenta : (it.Precio || 0));
                }

                it.montoManoDeObra = recItem.moPorUnidad > 0 ? Number(recItem.moPorUnidad.toFixed(2)) : 0;

                // Actualizar medidasReceta en el item
                it.medidasReceta = medidasJSON;
                it.MedidasReceta = medidasJSON;
                it.recetaInfo = nuevasMedidas;

                // Actualizar cantidad del insumo
                if (this.props.InputCantidadDetalleChange) {
                    this.props.InputCantidadDetalleChange({ target: { value: recItem.nuevaCantidad } }, it);
                }

                // Actualizar precio de venta (precio base + mano de obra distribuida)
                if (this.props.InputPrecioVentaChange) {
                    this.props.InputPrecioVentaChange({ target: { value: recItem.nuevoPrecioVenta } }, it);
                }
                if (this.props.onBlurPrecioVenta) {
                    this.props.onBlurPrecioVenta({ target: { value: recItem.nuevoPrecioVenta } }, it);
                }
            }
        }

        this.setState({ showModalRecetaDetails: false, grupoRecetaSeleccionado: null });
    };

    handleAplicarManoDeObraReceta = (grupo, montoManoDeObra) => {
        return this.handleGuardarCambiosReceta(grupo, {
            W: grupo?.recetaInfo?.W,
            H: grupo?.recetaInfo?.H,
            Cantidad: grupo?.recetaInfo?.Cantidad || 1,
            montoManoDeObra: montoManoDeObra,
            itemsRecalculados: (grupo?.items || []).map(it => ({
                item: it,
                nuevaCantidad: parseFloat(it.Cantidad ?? it.cantidad ?? 1),
                nuevoPrecioVenta: it.precioBase !== undefined ? it.precioBase : parseFloat(it.PrecioVenta || it.Precio || 0),
                moPorUnidad: 0
            }))
        });
    };

    openAreaModal = (det) => {
        let savedData = this.state.savedMeasurements[det.IdPresentacion];

        // Si no hay datos en memoria local, pero el backend nos envió MedidasExtras (al editar una preventa), lo parseamos
        if (!savedData && det.MedidasExtras) {
            try {
                savedData = JSON.parse(det.MedidasExtras);
                // Pre-poblamos el estado local con estos datos para futuras aperturas
                this.setState(prevState => ({
                    savedMeasurements: {
                        ...prevState.savedMeasurements,
                        [det.IdPresentacion]: savedData
                    }
                }));
            } catch (e) {
                console.error("Error al parsear MedidasExtras", e);
            }
        }

        this.setState({
            showAreaModal: true,
            selectedAreaItem: det,
            areaRows: savedData ? savedData.areaRows : [{ id: Date.now(), cantidad: 1, ancho: "", alto: "" }],
            factorDesperdicio: savedData ? savedData.factorDesperdicio : 1.40,
        });
    }

    closeAreaModal = () => {
        this.setState({
            showAreaModal: false,
            selectedAreaItem: null,
            areaRows: [{ id: 1, cantidad: 1, ancho: "", alto: "" }],
            factorDesperdicio: 1.40,
        });
    }

    handleAddRow = () => {
        const newRow = { id: Date.now(), cantidad: 1, ancho: "", alto: "" };
        console.log("[DetallesProductoPreventa] Agregando nueva fila:", newRow);
        this.setState(prevState => ({
            areaRows: [...prevState.areaRows, newRow]
        }));
    }

    handleRemoveRow = (id) => {
        this.setState(prevState => ({
            areaRows: prevState.areaRows.filter(row => row.id !== id)
        }));
    }

    handleRowChange = (id, field, value) => {
        console.log(`[DetallesProductoPreventa] Modificando fila ${id} | Campo: ${field} = ${value}`);
        this.setState(prevState => ({
            areaRows: prevState.areaRows.map(row =>
                row.id === id ? { ...row, [field]: value } : row
            )
        }));
    }

    handleFactorChange = (e) => {
        this.setState({ factorDesperdicio: e.target.value });
    }

    applyArea = () => {
        const { areaRows, selectedAreaItem, factorDesperdicio } = this.state;
        let totalM2 = 0;
        let totalPie2 = 0;

        console.log("[DetallesProductoPreventa] --- Aplicando Área Total ---");
        console.log("Unidad de Medida Producto:", selectedAreaItem.unidadMedida || selectedAreaItem.unidadMedidas);

        areaRows.forEach((row, index) => {
            console.log(`Calculando fila ${index + 1}:`, row);
            totalM2 += calculateAreaM2(row, factorDesperdicio);
            totalPie2 += calculateAreaPie2(row, factorDesperdicio);
        });

        const isPie = selectedAreaItem && (selectedAreaItem.unidadMedida || selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
        const finalArea = areaRows.reduce((sum, row) => {
            return sum + (isPie ? calculateAreaPie2(row, factorDesperdicio) : calculateAreaM2(row, factorDesperdicio));
        }, 0);

        if (finalArea > 0 && selectedAreaItem) {
            // Inyectar el JSON string para que viaje a la API
            selectedAreaItem.MedidasExtras = JSON.stringify({
                areaRows: this.state.areaRows,
                factorDesperdicio: this.state.factorDesperdicio
            });

            this.props.InputCantidadDetalleChange({
                target: { value: decimalAdjust('round', finalArea, -2) }
            }, selectedAreaItem);

            // Guardamos las medidas en el state para no perderlas al reabrir el modal
            this.setState(prevState => ({
                savedMeasurements: {
                    ...prevState.savedMeasurements,
                    [selectedAreaItem.IdPresentacion]: {
                        areaRows: prevState.areaRows,
                        factorDesperdicio: prevState.factorDesperdicio
                    }
                }
            }), () => {
                this.closeAreaModal();
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let divCarrito = $("#tableDetProdPreventa");
        let rows = $("#IdDetProductoCarrito").find('tr');

        if (rows.length >= 6 && !this.state.isEditing && this.props.detalles.length !== prevProps.detalles.length)
            divCarrito.scrollTop(divCarrito.prop('scrollHeight'))
    }

    async verificarPrecioCosto() {
        try {
            const responseVal = await fetch(`/api/prices/precioCosto/validar`);
            const data = await responseVal.json();
            this.setState({ verPrecios: true })
        } catch (e) {
            this.setState({ verPrecios: false })
        }
    }

    async componentDidMount() {
        this.setState({
            isEditing: window.location.href.includes("/edit/")
        })

        MagellanListener.addSubscriber(this);
        this.setState({ magellanListenerIsAvailable: MagellanListener.sourceIsRunning() });
        await this.verificarPrecioCosto()
    }

    requestWeight(detalle) {
        const add = this.props.detalles.some(p => p.IdProducto === detalle.IdProducto);
        MagellanListener.requestWeight(detalle.IdProducto, add);
    }

    onRecieveWeight(weight, owner, addWeight) {
        const detalle = this.props.detalles.find(p => p.IdProducto === owner);

        if (!detalle) {
            return;
        }

        this.props.InputCantidadDetalleChange({
            target: {
                value: addWeight ? (detalle.Cantidad + weight) - 1 : weight
            }
        }, detalle);
    }

    onMagellanChangeAvailability(availability) {
        this.setState({ magellanListenerIsAvailable: availability });
    }

    render() {
        let canUpdatePrice = !_.isUndefined(this.props.canUpdatePrice) ? this.props.canUpdatePrice : true;
        let canIncrementProductPrice = !!this.props.incrementarPrecioProd ? this.props.incrementarPrecioProd : false;

        return (
            <div id="tableDetProdPreventa" className="preventa__carrito mt-2">
                <table className="table table-hover" style={{ overflow: "hidden" }}>
                    <thead>
                        <tr>
                            <th className="tdDetallePreventa cabecera-tabla" style={{ borderRadius: '15px 15px 0 0', backgroundColor: "#01A59C" }}>

                                <div style={{ color: "white" }} className='inputDet'>CANTIDAD&nbsp;</div>
                                <div style={{ color: "white" }} className='inputDet'>/ PRECIO</div>
                                <div style={{ color: "white" }} className='inputDet'>/ TOTAL</div>
                                <div className='inputDet no-visible-resp' />
                            </th>
                        </tr>
                    </thead>
                    <tbody id="IdDetProductoCarrito">
                        {(() => {
                            const groupedDetalles = [];
                            const recetasGrouped = {};

                            this.props.detalles.forEach((det, i) => {
                                const grupoReceta = det.grupoReceta || det.GrupoReceta;
                                const medidasReceta = det.medidasReceta || det.MedidasReceta;

                                if (grupoReceta) {
                                    if (!recetasGrouped[grupoReceta]) {
                                        let recetaInfo = null;
                                        try {
                                            recetaInfo = medidasReceta ? (typeof medidasReceta === 'string' ? JSON.parse(medidasReceta) : medidasReceta) : null;
                                        } catch (e) {
                                            console.error("Error parsing medidasReceta", e);
                                        }

                                        if (this.state.recetasMedidas && this.state.recetasMedidas[grupoReceta]) {
                                            recetaInfo = {
                                                ...(recetaInfo || {}),
                                                ...this.state.recetasMedidas[grupoReceta]
                                            };
                                        }

                                        recetasGrouped[grupoReceta] = {
                                            isGrupoReceta: true,
                                            grupoReceta: grupoReceta,
                                            recetaInfo: recetaInfo,
                                            items: [],
                                            Total: 0,
                                            montoManoDeObra: this.state.recetasManoDeObra[grupoReceta] !== undefined
                                                ? this.state.recetasManoDeObra[grupoReceta]
                                                : 0
                                        };
                                        groupedDetalles.push(recetasGrouped[grupoReceta]);
                                    }
                                    recetasGrouped[grupoReceta].items.push(det);
                                    recetasGrouped[grupoReceta].Total += Number(det.Total || 0);
                                } else {
                                    groupedDetalles.push(det);
                                }
                            });

                            return groupedDetalles.map((det, i) => {
                                if (det.isGrupoReceta) {
                                    return (
                                        <tr key={`grupo-${det.grupoReceta}`} style={{ backgroundColor: '#e6f4ea' }}>
                                            <td style={{ maxWidth: '1em', padding: 0 }}>
                                                <div className="d-flex justify-content-between align-items-center p-2">
                                                    <div>
                                                        <span className="font-weight-bold" style={{ color: '#01a59c', fontSize: '15px' }}>
                                                            <i className="fas fa-cubes mr-2"></i>
                                                            {det.recetaInfo?.Nombre || 'Ventana'}
                                                            <span className="ml-2 badge badge-info">W: {det.recetaInfo?.W}m</span>
                                                            <span className="ml-1 badge badge-info">H: {det.recetaInfo?.H}m</span>
                                                            {Boolean(det.montoManoDeObra && Number(det.montoManoDeObra) > 0) && (
                                                                <span className="ml-2 badge badge-warning text-dark font-weight-bold" style={{ backgroundColor: '#ffc107', padding: '4px 8px' }}>
                                                                    <i className="fas fa-tools mr-1"></i> M.O.: S/ {Number(det.montoManoDeObra).toFixed(2)}
                                                                </span>
                                                            )}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <span className="font-weight-bold mr-4" style={{ fontSize: '16px' }}>
                                                            S/ {extractTwoDecimalsForNumber(det.Total)}
                                                        </span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-info mr-2"
                                                            onClick={() => {
                                                                const moFinal = this.state.recetasManoDeObra[det.grupoReceta] !== undefined
                                                                    ? this.state.recetasManoDeObra[det.grupoReceta]
                                                                    : (det.montoManoDeObra || 0);
                                                                det.montoManoDeObra = moFinal;

                                                                if (this.state.recetasMedidas && this.state.recetasMedidas[det.grupoReceta]) {
                                                                    det.recetaInfo = {
                                                                        ...(det.recetaInfo || {}),
                                                                        ...this.state.recetasMedidas[det.grupoReceta]
                                                                    };
                                                                }

                                                                console.log("%c[DetallesProductoPreventa] >> Abriendo modal Detalles de la Ventana", "background: #01a59c; color: white; font-weight: bold; padding: 2px 5px;");
                                                                console.log("Grupo Receta:", det.grupoReceta);
                                                                console.log("Medidas Receta Info:", det.recetaInfo);
                                                                console.log("Mano de Obra actual:", moFinal);
                                                                console.log("Items agrupados:", det.items);
                                                                console.log("Total acumulado grupo:", det.Total);

                                                                this.setState({
                                                                    showModalRecetaDetails: true,
                                                                    grupoRecetaSeleccionado: { ...det, recetaInfo: { ...(det.recetaInfo || {}) } }
                                                                });
                                                            }}
                                                        >
                                                            <i className="fas fa-search mr-1"></i> Detalles
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => this.props.RemoveGrupoRecetaInList && this.props.RemoveGrupoRecetaInList(det.grupoReceta)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                }

                                return (
                                    <tr
                                        // id={`det-${i}`}
                                        id={`producto-${det.IdPresentacion}-${i}`}
                                        key={`det-${det.IdPresentacion}-${i}`}
                                        bgcolor={this.props.defaultBgInProductDetail ? null : det.IdTipoStock === TIPO_STOCK.CON_COMPROBANTE ? "" : "#f78b2d"}
                                        className="trDetallePreventa"
                                        onKeyUp={(e) => this.props.onSecretKeyPress(e, det)}
                                    >
                                        <td className="pt-3 pl-3">
                                            <div>
                                                <div style={{ fontSize: "14px" }} className="itemNombre">
                                                    <div>
                                                        {
                                                            String(det.EsFacturable) === "1" ? `${det.descripcion} ${det.unidadMedida}`
                                                                :
                                                                (
                                                                    <strong>
                                                                        <p className="fw-bolder"
                                                                            style={{ color: "#01a59c" }}>
                                                                            {det.descripcion} {det.unidadMedidas}
                                                                        </p>
                                                                    </strong>
                                                                )
                                                        }

                                                    </div>
                                                    {Boolean(det.in_mano_de_obra && det.in_mano_de_obra !== "0" && det.in_mano_de_obra !== 0) && (
                                                        <div className="d-flex align-items-center mt-1 mb-1 flex-wrap" style={{ fontSize: "12px" }}>
                                                            <span className="badge badge-warning mr-2 text-dark" style={{ backgroundColor: "#ffc107", fontWeight: "600", padding: "4px 8px" }}>
                                                                Mano de Obra:
                                                            </span>
                                                            <div className="input-group input-group-sm" style={{ width: "125px" }}>
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text py-0 px-2 font-weight-bold" style={{ fontSize: "12px", background: "#f0f2f5" }}>S/</span>
                                                                </div>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    placeholder="0.00"
                                                                    className="form-control form-control-sm text-right"
                                                                    style={{ height: "28px", fontSize: "12px", fontWeight: "bold", color: "#856404", backgroundColor: "#fff9e6" }}
                                                                    value={det.montoManoDeObra !== undefined ? det.montoManoDeObra : ""}
                                                                    onClick={(e) => e.target.select()}
                                                                    onChange={(e) => this.handleManoDeObraChange(e, det)}
                                                                    onBlur={(e) => this.handleManoDeObraBlur(e, det)}
                                                                    disabled={this.props.readOnly || this.props.load}
                                                                />
                                                            </div>
                                                            {det.precioBase !== undefined && (
                                                                <span className="ml-2 text-muted" style={{ fontSize: "11px" }}>
                                                                    (Base: S/ {Number(det.precioBase).toFixed(2)})
                                                                </span>
                                                            )}
                                                        </div>
                                                    )}
                                                    {
                                                        !this.state.isEditing && <div className="botones-desk">
                                                            {this.props.venderConListaPrecios === 1 ?
                                                                (

                                                                    <select
                                                                        required
                                                                        disabled={this.props.load}
                                                                        className="mt-1 mr-1"
                                                                        value={det.Precio}
                                                                        onChange={(e) => {
                                                                            det.precioBase = parseFloat(e.target.value) || 0;
                                                                            det.montoManoDeObra = "";
                                                                            this.props.PrecioChange(e, det);
                                                                        }}
                                                                    >
                                                                        <option value={det.PrecioMenor}>
                                                                            Menor/Lista
                                                                        </option>
                                                                        <option value={det.PrecioFamiliar}>
                                                                            Familiar
                                                                        </option>
                                                                        <option value={det.PrecioEspecial}>
                                                                            Especial
                                                                        </option>
                                                                    </select>
                                                                ) : null
                                                            }
                                                            {this.state.verPrecios ?
                                                                (
                                                                    <div>
                                                                        Precio Costo:
                                                                        {det.PrecioCosto
                                                                            .toLocaleString("en-GB", {
                                                                                minimumFractionDigits: 2,
                                                                                maximumFractionDigits: 2
                                                                            })}
                                                                    </div>
                                                                ) :
                                                                null
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="tdDetallePreventa-desk" key={`div-det-${det.IdPresentacion}-${i}`}>

                                                <div className="inputDet">
                                                    {(this.state.magellanListenerIsAvailable && 'unidadMedida' in det && det.unidadMedida === KILOGRAMO_UNIT_DESCRIPTION)
                                                        ? <input type="number" style={{ backgroundColor: "rgb(53,96,90,0.18)" }} className="inputCantidadDet" name="Cantidad" value={det.Cantidad} readOnly /> :
                                                        <input
                                                            onClick={(e) => {
                                                                e.target.select()
                                                            }}
                                                            readOnly={this.props.load}
                                                            type="number"
                                                            style={{ backgroundColor: "rgb(53,96,90,0.18)" }}
                                                            step="1"
                                                            min="1"
                                                            name="Cantidad"
                                                            value={det.Cantidad}
                                                            className="inputCantidadDet"
                                                            onChange={e => this.props.InputCantidadDetalleChange(e, det)}
                                                            onBlur={e => this.props.onBlurInputCantidad(e, det)}
                                                            disabled={this.props.readOnly}
                                                        />
                                                    }

                                                </div>
                                                <div className="inputDet">
                                                    {canUpdatePrice || canIncrementProductPrice ? (

                                                        <input
                                                            onClick={(e) => {
                                                                e.target.select()
                                                            }}
                                                            readOnly={this.props.load}
                                                            type="number"
                                                            style={{ backgroundColor: "#01a59c", color: "white" }}
                                                            step="1"
                                                            min="0"
                                                            value={det.PrecioVenta}
                                                            onChange={e => {
                                                                det.precioBase = parseFloat(e.target.value) || 0;
                                                                det.montoManoDeObra = "";
                                                                this.props.InputPrecioVentaChange(e, det);
                                                            }}
                                                            name="PrecioVenta"
                                                            className="inputPrecioVentaDet"
                                                            onBlur={e => this.props.onBlurPrecioVenta(e, det)}
                                                            disabled={this.props.readOnly}
                                                        />

                                                    ) : (

                                                        <input
                                                            onClick={(e) => {
                                                                e.target.select()
                                                            }}
                                                            readOnly={true}
                                                            type="number"
                                                            style={{ backgroundColor: "#01a59c", color: "white" }}
                                                            step="1"
                                                            min="0"
                                                            disabled={true}
                                                            value={det.PrecioVenta}
                                                            name="PrecioVenta"
                                                            className="inputPrecioVentaDet"
                                                        />
                                                    )}
                                                </div>


                                                <div className="inputDet">
                                                    {/*{this.props.canUpdateTotal ?*/}
                                                    <input type="number"
                                                        onChange={e => this.props.onChangeTotal(e, det)}
                                                        onBlur={e => this.props.onBlurTotal(e, det)}
                                                        onClick={e => e.target.select()}
                                                        readOnly={!this.props.canUpdateTotal}
                                                        style={{ backgroundColor: "#034b2f", color: "white" }}
                                                        value={decimalAdjust('round', det.Total - (det.Total * this.props.descuentoPorCliente / 100), -2)}
                                                        className="inputPrecioVentaDet"
                                                        disabled={this.props.readOnly}
                                                    />
                                                    {/*// decimalAdjust('round',det.Total - (det.Total * this.props.descuentoPorCliente/100), -2)*/}
                                                    {/*}*/}
                                                </div>

                                                <div>

                                                    {!this.props.readOnly && this.queryParams.get('disabled') !== 'true' && <div>
                                                        {(this.state.magellanListenerIsAvailable && 'unidadMedida' in det && det.unidadMedida === KILOGRAMO_UNIT_DESCRIPTION) ?
                                                            <BotonPesar
                                                                disabled={this.props.load}
                                                                className="ml-2"
                                                                type="button"
                                                                title="Pesar"
                                                                onClick={() => this.requestWeight(det)}
                                                            /> :
                                                            <>
                                                                <BotonMenosPequeño
                                                                    disabled={this.props.load}
                                                                    className="ml-2"
                                                                    type="button"
                                                                    title="Disminuir en 1"
                                                                    onClick={() =>
                                                                        this.props.RestarCantidadDet(det)
                                                                    }
                                                                />

                                                                <BotonAddPequeño
                                                                    disabled={this.props.load}
                                                                    className="ml-2"
                                                                    type="button"
                                                                    title="Aumentar en 1"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation()
                                                                        this.props.AgregarCantidadDet(det)
                                                                    }}
                                                                />
                                                                {Boolean(det.in_medidas && det.in_medidas !== "0" && det.in_medidas !== 0) &&
                                                                    <BotonMedirArea
                                                                        disabled={this.props.load}
                                                                        className="ml-2"
                                                                        type="button"
                                                                        title="Medir Área"
                                                                        onClick={() => this.openAreaModal(det)}
                                                                    />
                                                                }
                                                            </>
                                                        }


                                                        <BotonRemovePequeño
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            type="button"
                                                            title="Quitar item"
                                                            onClick={() =>
                                                                this.props.RemoveProductoInList(det)
                                                            }
                                                        />

                                                        <BotonDown
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            onClick={() => this.props.handleOpenModalDescuento(det)}
                                                            title="Descuento"
                                                        />
                                                    </div>}
                                                </div>
                                            </div>
                                            <div className="tdDetallePreventa-resp " key={`div-det-${det.IdPresentacion}-${i}`}
                                                style={{ height: "75px", padding: "20px 0px 0px 0px" }}>
                                                <div className="">
                                                    <div className="d-flex">
                                                        <div className="no-pad">
                                                            <input
                                                                onClick={(e) => {
                                                                    e.target.select()
                                                                }}
                                                                readOnly={this.props.load}
                                                                type="number"
                                                                style={{ backgroundColor: "rgb(53,96,90,0.18)" }}
                                                                step="1"
                                                                min="1"
                                                                name="Cantidad"
                                                                value={det.Cantidad}
                                                                className="inputCantidadDet"
                                                                onChange={e => this.props.InputCantidadDetalleChange(e, det)}
                                                                onBlur={e => this.props.onBlurInputCantidad(e, det)}
                                                            />
                                                        </div>
                                                        <div className="no-pad">
                                                            {canUpdatePrice ? (

                                                                <input
                                                                    onClick={(e) => {
                                                                        e.target.select()
                                                                    }}
                                                                    readOnly={this.props.load}
                                                                    type="number"
                                                                    style={{ backgroundColor: "#01a59c", color: "white" }}
                                                                    step="1"
                                                                    min="0"
                                                                    value={det.PrecioVenta}
                                                                    onChange={e => {
                                                                        det.precioBase = parseFloat(e.target.value) || 0;
                                                                        det.montoManoDeObra = "";
                                                                        this.props.InputPrecioVentaChange(e, det);
                                                                    }}
                                                                    name="PrecioVenta"
                                                                    className="inputPrecioVentaDet"
                                                                    onBlur={e => this.props.onBlurPrecioVenta(e, det)}
                                                                />

                                                            ) : (

                                                                <input
                                                                    onClick={(e) => {
                                                                        e.target.select()
                                                                    }}
                                                                    readOnly={true}
                                                                    type="number"
                                                                    style={{ backgroundColor: "#01a59c", color: "white" }}
                                                                    step="1"
                                                                    min="0"
                                                                    disabled={true}
                                                                    value={det.PrecioVenta}
                                                                    name="PrecioVenta"
                                                                    className="inputPrecioVentaDet"
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="no-pad">
                                                            {this.props.canUpdateTotal ?
                                                                <input type="number"
                                                                    onChange={e => this.props.onChangeTotal(e, det)}
                                                                    onBlur={e => this.props.onBlurTotal(e, det)}
                                                                    onClick={e => e.target.select()}
                                                                    readOnly={this.props.load}
                                                                    style={{ backgroundColor: "#034b2f", color: "white" }}
                                                                    value={decimalAdjust('round', det.Total, -2)}
                                                                    className="inputPrecioVentaDet" /> :
                                                                decimalAdjust('round', det.Total, -2)
                                                            }
                                                        </div>
                                                        <div className="dropdown drop-resp ml-2 mr-2">
                                                            <button className="btn options-ventas" type="button"
                                                                data-toggle="dropdown" aria-expanded="false">

                                                            </button>
                                                            <div className="dropdown-menu">
                                                                <a className="dropdown-item">
                                                                    <BotonMenosPequeño
                                                                        disabled={this.props.load}
                                                                        className="ml-2"
                                                                        type="button"
                                                                        title="Disminuir en 1"
                                                                        onClick={() =>
                                                                            this.props.RestarCantidadDet(det)
                                                                        }
                                                                    />
                                                                </a>
                                                                <a className="dropdown-item">
                                                                    <BotonAddPequeño
                                                                        disabled={this.props.load}
                                                                        className="ml-2"
                                                                        type="button"
                                                                        title="Aumentar en 1"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            this.props.AgregarCantidadDet(det)
                                                                        }}
                                                                    />
                                                                </a>
                                                                {Boolean(det.in_medidas && det.in_medidas !== "0" && det.in_medidas !== 0) &&
                                                                    <a className="dropdown-item">
                                                                        <BotonMedirArea
                                                                            disabled={this.props.load}
                                                                            className="ml-2"
                                                                            type="button"
                                                                            title="Medir Área"
                                                                            onClick={() => this.openAreaModal(det)}
                                                                        />
                                                                    </a>
                                                                }
                                                                <a className="dropdown-item">
                                                                    <BotonRemovePequeño
                                                                        disabled={this.props.load}
                                                                        className="ml-2"
                                                                        type="button"
                                                                        title="Quitar item"
                                                                        onClick={() =>
                                                                            this.props.RemoveProductoInList(det)
                                                                        }
                                                                    />
                                                                </a>
                                                                <a className="dropdown-item">
                                                                    <BotonDown
                                                                        disabled={this.props.load}
                                                                        className="ml-2"
                                                                        onClick={() => this.props.handleOpenModalDescuento(det)}
                                                                        title="Descuento"
                                                                    />
                                                                </a>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-12 col-md-6 d-flex justify-content-center mt-3" style={{visibility: "hidden"}}>
                                                    <div>
                                                        <BotonMenosPequeño
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            type="button"
                                                            title="Disminuir en 1"
                                                            onClick={() =>
                                                                this.props.RestarCantidadDet(det)
                                                            }
                                                        />
                                                        <BotonAddPequeño
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            type="button"
                                                            title="Aumentar en 1"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                this.props.AgregarCantidadDet(det)
                                                            }}
                                                        />
                                                        <BotonRemovePequeño
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            type="button"
                                                            title="Quitar item"
                                                            onClick={() =>
                                                                this.props.RemoveProductoInList(det)
                                                            }
                                                        />
                                                        <BotonDown
                                                            disabled={this.props.load}
                                                            className="ml-2"
                                                            onClick={() => this.props.handleOpenModalDescuento(det)}
                                                            title="Descuento"
                                                        />
                                                    </div>
                                                </div> */}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            });
                        })()}
                    </tbody>
                </table>
                <CoreModal
                    isOpen={this.state.showModalRecetaDetails}
                    onClose={() => this.setState({ showModalRecetaDetails: false, grupoRecetaSeleccionado: null })}
                    title="Detalles de la Ventana"
                    className="modal-xl"
                >
                    {this.state.showModalRecetaDetails && this.state.grupoRecetaSeleccionado && (
                        <ModalRecetaCartSVG
                            key={`${this.state.grupoRecetaSeleccionado.grupoReceta}-${this.state.grupoRecetaSeleccionado.recetaInfo?.W}-${this.state.grupoRecetaSeleccionado.recetaInfo?.H}-${this.state.grupoRecetaSeleccionado.recetaInfo?.Cantidad}`}
                            grupo={this.state.grupoRecetaSeleccionado}
                            onCancel={() => this.setState({ showModalRecetaDetails: false, grupoRecetaSeleccionado: null })}
                            onGuardarCambiosReceta={this.handleGuardarCambiosReceta}
                            onAplicarManoDeObra={this.handleAplicarManoDeObraReceta}
                        />
                    )}
                </CoreModal>

                <Modal isOpen={this.state.showAreaModal} onClose={this.closeAreaModal} title="Medidas">
                    {this.state.selectedAreaItem && (
                        <div className="mb-3 d-flex flex-wrap justify-content-between text-left" style={{ fontSize: "14px", backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "5px", gap: "10px" }}>
                            <div><strong>Producto:</strong> {this.state.selectedAreaItem.descripcion}</div>
                            <div className="d-flex align-items-center">
                                <strong>Factor desperdicio por lado cm:&nbsp;</strong>
                                <input type="number" className="form-control form-control-sm" disabled value={this.state.factorDesperdicio} onChange={this.handleFactorChange} style={{ width: "70px" }} />
                            </div>
                            {/* <div><strong>ID Item:</strong> {this.state.selectedAreaItem.IdProducto || this.state.selectedAreaItem.IdPresentacion}</div> */}
                            <div><strong>Unidad de Medida:</strong> {this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas}</div>
                        </div>
                    )}

                    <div className="table-responsive">
                        {(() => {
                            const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                            return (
                                <table className="table table-bordered table-sm text-center" style={{ fontSize: "12px", verticalAlign: "middle" }}>
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Cant.<br />(und)</th>
                                            <th>Ancho<br />(cm)</th>
                                            <th>Alto<br />(cm)</th>
                                            <th>Área<br />(Pie2)</th>
                                            <th>Área<br />(m2)</th>
                                            <th>Desperdicio<br />({isPie ? 'Pie2' : 'm2'})</th>
                                            <th>Precio</th>
                                            <th>Total</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.areaRows.map((row, index) => {
                                            const areaPie2 = calculateAreaPie2(row, this.state.factorDesperdicio);
                                            const areaM2 = calculateAreaM2(row, this.state.factorDesperdicio);
                                            const wastePie2 = calculateWastePie2(row, this.state.factorDesperdicio);
                                            const wasteM2 = calculateWasteM2(row, this.state.factorDesperdicio);

                                            const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                                            const precio = this.state.selectedAreaItem ? parseFloat(this.state.selectedAreaItem.PrecioVenta) || 0 : 0;

                                            const total = isPie ? areaPie2 * precio : areaM2 * precio;
                                            const desperdicio = isPie ? wastePie2 : wasteM2;

                                            // LOG PARA RASTREAR EL CÁLCULO DEL TOTAL
                                            if (row.ancho && row.alto) {
                                                console.log(`[Cálculo de Total Fila ${index + 1}] Unidad: ${isPie ? 'Pie2' : 'm2'}, Área Utilizada: ${isPie ? areaPie2 : areaM2} * Precio: ${precio} = Total Precio Fila: ${total}`);
                                            }

                                            return (
                                                <tr key={row.id}>
                                                    <td><input type="number" className="form-control form-control-sm" value={row.cantidad} onChange={(e) => this.handleRowChange(row.id, 'cantidad', e.target.value)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" value={row.ancho} onChange={(e) => this.handleRowChange(row.id, 'ancho', e.target.value)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" value={row.alto} onChange={(e) => this.handleRowChange(row.id, 'alto', e.target.value)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={areaPie2.toFixed(3)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={areaM2.toFixed(3)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={desperdicio.toFixed(2)} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" value={precio} onChange={(e) => {
                                                        const newPrecio = e.target.value;
                                                        if (this.props.InputPrecioVentaChange) {
                                                            this.props.InputPrecioVentaChange({ target: { name: 'PrecioVenta', value: newPrecio } }, this.state.selectedAreaItem);
                                                        }
                                                        this.setState(prevState => ({
                                                            selectedAreaItem: {
                                                                ...prevState.selectedAreaItem,
                                                                PrecioVenta: newPrecio
                                                            }
                                                        }));
                                                    }} /></td>
                                                    <td><input type="number" className="form-control form-control-sm" readOnly value={total.toFixed(2)} /></td>
                                                    <td style={{ minWidth: "110px" }}>
                                                        <div className="d-flex justify-content-center align-items-center" style={{ gap: "5px" }}>
                                                            <button type="button" className="btn btn-danger btn-sm" title="Eliminar fila" onClick={() => this.handleRemoveRow(row.id)} disabled={this.state.areaRows.length === 1}>
                                                                <i className="fas fa-trash"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot className="table-active font-weight-bold">
                                        <tr>
                                            <td colSpan="3" className="text-right">Sumas Totales:</td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row) => sum + calculateAreaPie2(row, this.state.factorDesperdicio), 0).toFixed(3)}
                                            </td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row) => sum + calculateAreaM2(row, this.state.factorDesperdicio), 0).toFixed(3)}
                                            </td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row) => {
                                                    const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                                                    return sum + (isPie ? calculateWastePie2(row, this.state.factorDesperdicio) : calculateWasteM2(row, this.state.factorDesperdicio));
                                                }, 0).toFixed(2)}
                                            </td>
                                            <td></td>
                                            <td>
                                                {this.state.areaRows.reduce((sum, row, index) => {
                                                    const precio = this.state.selectedAreaItem ? parseFloat(this.state.selectedAreaItem.PrecioVenta) || 0 : 0;
                                                    const isPie = this.state.selectedAreaItem && (this.state.selectedAreaItem.unidadMedida || this.state.selectedAreaItem.unidadMedidas || "").toUpperCase().includes('PIE');
                                                    const rowTotal = isPie ? calculateAreaPie2(row, this.state.factorDesperdicio) * precio : calculateAreaM2(row, this.state.factorDesperdicio) * precio;
                                                    const newSum = sum + rowTotal;
                                                    if (row.ancho && row.alto) {
                                                        console.log(`[Cálculo Total Acumulado] Fila ${index + 1}: ${rowTotal} + Suma Anterior: ${sum} = Total Acumulado: ${newSum}`);
                                                    }
                                                    return newSum;
                                                }, 0).toFixed(2)}
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            );
                        })()}
                    </div>

                    <div className="mb-3 text-left">
                        <button type="button" className="btn btn-success btn-sm" onClick={this.handleAddRow}><i className="fas fa-plus"></i> Agregar Fila</button>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                        <button type="button" className="btn btn-danger mr-2" onClick={this.closeAreaModal}>Cancelar</button>
                        <button type="button" className="btn btn-verde-mfp" onClick={this.applyArea}>Aplicar Cantidad</button>
                    </div>
                </Modal>
            </div>
        );
    }

}
